<template>
  <b-modal :active.sync="isModalActive" scroll="keep">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="rounded-lg shadow-xl bg-white overflow-hidden border border-gray-200 border-[#E4E6EB]">
      <!-- HEADER sin fondo gris -->
      <!-- <header class="flex justify-between items-start flex-wrap gap-2 text-sm font-medium text-gray-800 px-6 py-4 border-b border-[#E4E6EB] uppercase tracking-wide">
        <div class="flex-1 min-w-0">
          <h2 class="break-words whitespace-normal">
            <div><b>Actividades vinculadas</b></div>
          </h2>
        </div>
        <div class="flex-shrink-0">
        </div>
      </header> -->

      <!-- BODY con fondo blanco liso -->
      <div class="px-6- py-5- space-y-4 bg-white">

        <div class="w-full bg-gray-50 p-4 flex justify-center items-center rounded-lg shadow-md" style="display:grid">
          <b-field v-if="!imagePreview" class="inline-block">
            <b-upload v-model="dropFileTemp" drag-drop expanded accept="image/*" @input="onImageSelected">
              <section class="section">
                <div class="content has-text-centered">
                  <p>
                    <b-icon icon="upload" size="is-large" pack="fas"></b-icon>
                  </p>
                  <p>{{ $t('drag_file_or_click_select') }}</p>
                </div>
              </section>
            </b-upload>
          </b-field>

          <b-field>
            <div v-if="imagePreview" class="w-full mt-4 relative">
              <img :src="imagePreview" alt="preview" style="max-width: 300px; border-radius: 8px;" />
              <div class="absolute top-0 right-0 m-2">
                <button class="delete is-small"
                  type="button"
                  @click="deleteDropFile">
                </button>
              </div>
            </div>
          </b-field>

          <b-input class="inline-block" v-model="uploadImageName"
            type="is-primary" :placeholder="$t('name_image')">
          </b-input>

          <b-button type="is-primary" class="mt-2" @click="loadImagen">
            <b-icon pack="fas" icon="upload"></b-icon>
            <span>{{ $t('upload_image') }}</span>
          </b-button>

        </div>


      </div>

      <!-- FOOTER sin fondo gris, solo borde superior -->
      <!-- <footer class="px-6 py-4 border-t border-[#E4E6EB] bg-white">
        <div class="w-full flex justify-end space-x-2">
            <v-button v-if="!processingData" @click="linkGroup()" icon="plus">{{ $t('link_group') }}</v-button>
            <v-button v-if="!processingData" color="grey" icon="door-closed" @click="isModalActive = false">{{ $t('close') }}</v-button>

            <v-button-processing v-if="processingData" />
        </div>
      </footer> -->
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import SelectResource from './select-resource.vue';

export default {
  name: "load-resource-modal",

  components: {
    SelectResource
  },

  props: {

  },

  data() {
    return {
      processingData: false,
      isModalActive: false,
      isLoading: false,

      dropFileTemp: null,
      uploadImageName: null,
      imagePreview: null,

      tabId: null,
      loadImageIdx: null,

      isGantt: false,

    }
  },

  computed: {

  },

  created() {

  },

  mounted() {

  },

  methods: {

    async loadImagen() {
      if (this.dropFileTemp) {
        if (!this.uploadImageName) {
          this.uploadImageName = this.dropFileTemp.name
        }
        // compress image
        let maxSize = 600;
        let quality = 0.8;
        if (this.isGantt) {
          maxSize = 2000;
          quality = 0.9;
        }
        const compressedImage = await this.resizeAndCompressImage(this.dropFileTemp, maxSize, quality)

        const image = {
          name: this.uploadImageName,
          image: compressedImage
        }

        this.$emit('load:image_section', { tabId: this.tabId, loadImageIdx: this.loadImageIdx, image })

      } else {
        this.$notify.error('error_uploading_image')
      }
    },

    resizeAndCompressImage(file, maxSize, quality) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            const ratio = Math.min(maxSize / img.width, maxSize / img.height);
            const width = img.width * ratio;
            const height = img.height * ratio;

            canvas.width = width;
            canvas.height = height;

            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
              (blob) => {
                if (blob) {
                  resolve(new File([blob], file.name, { type: blob.type }));
                } else {
                  resolve(file);
                }
              },
              'image/jpeg',
              quality
            );
          };
          img.src = event.target.result;
        };

        reader.onerror = (error) => {
          resolve(file);
        };

        reader.readAsDataURL(file);
      });
    },

    onImageSelected(file) {
      if (!file) {
        this.imagePreview = null;
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file);

      this.uploadImageName = file.name;
    },

    deleteDropFile() {
      this.dropFileTemp = null;
      this.uploadImageName = null;
      this.imagePreview = null;
    },

    show(data) {
      this.tabId = data.tabId;
      this.loadImageIdx = data.imgIndex;
      this.isGantt = data.isGantt || false;

      this.isModalActive = true;
    },

    hide() {
      this.dropFileTemp = null
      this.uploadImageName = null
      this.tabId = null;
      this.loadImageIdx = null;
      this.imagePreview = null;

      this.isModalActive = false;
    }
  }
};
</script>
<style scoped>
/* Oculta los botones para aumentar los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
